var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCenters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4908_9032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.375 18.3125H41.4688V11.1875C41.4677 10.243 41.092 9.33749 40.4241 8.66963C39.7563 8.00177 38.8507 7.62608 37.9062 7.625H20.0938C19.1492 7.62608 18.2437 8.00177 17.5759 8.66963C16.908 9.33749 16.5323 10.243 16.5312 11.1875V18.3125H7.625C6.6805 18.3136 5.77499 18.6893 5.10713 19.3571C4.43927 20.025 4.06358 20.9305 4.0625 21.875V50.375C4.06358 51.3195 4.43927 52.225 5.10713 52.8929C5.77499 53.5607 6.6805 53.9364 7.625 53.9375H50.375C51.3195 53.9364 52.225 53.5607 52.8929 52.8929C53.5607 52.225 53.9364 51.3195 53.9375 50.375V21.875C53.9364 20.9305 53.5607 20.025 52.8929 19.3571C52.225 18.6893 51.3195 18.3136 50.375 18.3125ZM7.625 50.375V21.875H16.5312V25.4375H12.9688V29H16.5312V32.5625H12.9688V36.125H16.5312V39.6875H12.9688V43.25H16.5312V50.375H7.625ZM37.9062 50.375H20.0938V11.1875H37.9062V50.375ZM50.375 50.375H41.4688V43.25H45.0312V39.6875H41.4688V36.125H45.0312V32.5625H41.4688V29H45.0312V25.4375H41.4688V21.875H50.375V50.375Z",
    fill: "#60EC2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5625 14.75H25.4375V18.3125H32.5625V14.75Z",
    fill: "#60EC2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5625 21.875H25.4375V25.4375H32.5625V21.875Z",
    fill: "#60EC2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5625 29H25.4375V32.5625H32.5625V29Z",
    fill: "#60EC2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4908_9032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenters);
export default __webpack_public_path__ + "static/media/centers.1f2b49d7d81b79d1c9472154c5b25a4f.svg";
export { ForwardRef as ReactComponent };